import React from 'react';

import ModelTypeConstants from 'constants/ModelTypeConstants';
import {ParentStorableData} from 'constants/SampleConstants';
import ChangeParentStorableButton from 'samples/storables/ChangeParentStorableButton';
import useSkippableStorableSummaryQuery from 'samples/storables/graphql/useSkippableStorableSummaryQuery';
import {ButtonSize, ButtonStyle} from 'ui-library/buttons/Button';

interface LocationEditorProps {
  value: string | null;
  onChange: (parentStorageId: string | null) => void;
  required: boolean;
  disabled?: boolean;
}

export default function LocationEditor({
  value,
  onChange,
  required,
  disabled,
}: LocationEditorProps): JSX.Element {
  const storable = useSkippableStorableSummaryQuery(value);
  const buttonText =
    value == null
      ? required
        ? 'Choose location'
        : 'Leave location unchanged'
      : (storable?.name ?? 'Loading...');
  return (
    <ChangeParentStorableButton
      buttonStyle={ButtonStyle.TERTIARY_GRAY}
      buttonSize={ButtonSize.SMALL}
      buttonText={buttonText}
      fullWidth={true}
      icon={ModelTypeConstants.LOCATION}
      isWritable={!disabled}
      titleText="Move to..."
      parentStorableTypesOverride={[ModelTypeConstants.LOCATION]}
      showRegistrySelector={true}
      initialSelectedParentId={value}
      allowNone={!required}
      onSetParentStorable={(data: ParentStorableData) => {
        onChange(data.id);
      }}
    />
  );
}
